import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../redux/baseQuery";

interface ApiConfig {
  webhook: string;
}

interface CreateUserConfigBody {
  user: string;
  api: ApiConfig;
  email: string;
  profileId: string;
  created_at: string;
  updated_at: string;
}

interface CreateUserConfigResponse {
  data: { message?: string; success: boolean };
}

export const createUserConfigApi = createApi({
  reducerPath: "userConfigApi",
  baseQuery,
  tagTypes: ["UserConfig"],
  endpoints: (builder) => ({
    createUserConfig: builder.mutation<CreateUserConfigResponse, CreateUserConfigBody>({
      query: (body) => ({
        url: "userconfig",
        method: "POST",
        body,
      }),
      invalidatesTags: ["UserConfig"],
    }),
  }),
});

export const { useCreateUserConfigMutation } = createUserConfigApi;
